import { Divider as MuiDivider, type DividerProps as MuiDividerProps } from "@mui/material";

export type DividerProps = MuiDividerProps;
export const Divider = MuiDivider;
